"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validationSchema = void 0;
const yup_1 = require("yup");
const constants_1 = require("@dzambalaorg/constants");
const mui_inputs_asset_1 = require("@dzambalaorg/mui-inputs-asset");
exports.validationSchema = (0, yup_1.object)().shape({
    item: mui_inputs_asset_1.templateAssetValidationSchema,
    price: mui_inputs_asset_1.templateAssetValidationSchema,
    startTimestamp: (0, yup_1.string)()
        .matches(constants_1.reISO8601, "form.validations.patternMismatch")
        .required("form.validations.valueMissing"),
    endTimestamp: (0, yup_1.string)()
        .matches(constants_1.reISO8601, "form.validations.patternMismatch")
        .required("form.validations.valueMissing"),
});
//# sourceMappingURL=validation.js.map